@if (user$ | async; as user) {
    <div class="d-flex align-items-center mb-5">
        <ngxh6-usericon class="float-left me-3" size="large" [user]="user.data" [showTooltip]="false"></ngxh6-usericon>
        <h1 class="my-0 flex-grow-1">{{ user.data.name }}</h1>
        @if (userService.isGranted('ROLE_ADMIN')) {
            <div class="ms-auto">
                <a class="btn-sm btn btn-light mt-2 ms-2" (click)="userService.impersonate(user.data.email)" ngbTooltip="Perform actions as this user." container="body">
                    <i class="fa fa-wand-sparkles"></i> Impersonate
                </a>
            </div>
        }
    </div>
    <ngxh6-tabs [splitIndex]="1" [containerClass]="'content-container'" [navItems]="navItems" [content]="tabContent"></ngxh6-tabs>
    <ng-template #tabContent let-id="id">
        @if (id === 'edit') {
            <ngxh6-form-embed
                [options]="{ sticky_actions: true, show_back: false }"
                [model]="user.data"
                [formName]="'user'"
                [editId]="user.data.id"
                (submitted)="returnToList()"
            ></ngxh6-form-embed>
        }
        @if (id === 'notes') {
            <ngxh6-notes [objectId]="user.data.id"></ngxh6-notes>
        }
        @if (id === 'history') {
            <ngxh6-history [objectId]="user.data.id"></ngxh6-history>
        }
        @if (id === 'attendance') {
            <app-attendance-staff [objectId]="user.data.id"></app-attendance-staff>
        }
    </ng-template>
} @else {
    @if (error) {
        <ngxh6-api-error [error]="error"></ngxh6-api-error>
    } @else {
        <ngxh6-loading-spinner></ngxh6-loading-spinner>
    }
}
